import { useEffect, useState } from 'react';
import firebase from 'firebase/compat/app';

const useBonusExplainerMarkdown = ({
  accountId,
  bonusProgramId,
}: {
  accountId: string;
  bonusProgramId: string;
}) => {
  const [markdown, setMarkdown] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isActive = true;
    setIsLoading(true);
    const path = `accounts/${accountId}/bonus/${bonusProgramId}_bonus_explainer.md`;
    firebase
      .storage()
      .ref(path)
      .getDownloadURL()
      .then((url) => fetch(url))
      .then((res) => res.text())
      .then((text) => {
        if (isActive) {
          setMarkdown(text);
          setIsLoading(false);
        }
      })
      .catch(() => {
        if (isActive) {
          setIsLoading(false);
        }
      });
    return () => {
      isActive = false;
    };
  }, [accountId, bonusProgramId]);

  return { markdown, isLoading };
};

export default useBonusExplainerMarkdown;
